module.exports = __webpack_public_path__ + "static/media/raymond_phan.5572e2d2.png";